//import Splide from "@splidejs/splide";
//import '@splidejs/splide/css/core';
/*
if (document.querySelectorAll('[data-component="carousel"]').length > 0) {

    document.addEventListener('DOMContentLoaded', function () {

        new Splide('.splide').mount();
    })
}
*/
import Swiper from 'swiper/bundle';

// 2 Rows Gallery Carousel
var backButton = '<span class="slick-prev"><i class="fa-light fa-chevron-left"></i></span>';
var nextButton = '<span class="slick-next"><i class="fa-light fa-chevron-right"></i></span>'
var slickoptions = {
    rows: 2,
    dots: false,
    //appendDots: $(".slick-nav"),
    appendArrows: $(".gallery-nav"),
    accessibility: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    variableWidth: true,
    prevArrow: backButton,
    nextArrow: nextButton,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                rows: 2,
                slidesToScroll: 1,
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 480,
            settings: {
                rows: 4,
                slidesPerRow: 1,
                slidesToScroll: 1,
                slidesToShow: 1,
            },
        },
    ],
};

$(document).ready(function () {
    $(".galleryImages").slick(slickoptions);

    var slider = $(".galleryImages");
    var allSlides = $(".slick-slide > div > *").clone();
    var trigger = $("js-filter");

    var ClassFilter = function (object, item) {
        this.object = object;
        this.item = item;

        this.filterFunc = function () {
            $(".active").removeClass("active");
            $('.js-filter[data-filter="' + this.item + '"]').addClass("active");
            var filterSlides = allSlides.filter(this.item);

            slider.css({ opacity: "0", left: "50px" });
            setTimeout(function () {
                slider.slick("unslick").empty().append(filterSlides).slick(slickoptions).css({ opacity: "100", left: "0px" });
            }, 600);
        };
    };

    jQuery(".js-filter").on("click", function (e) {
        var attr = jQuery(this).attr("data-filter");
        var newFilter = new ClassFilter(this, attr);
        newFilter.filterFunc();
    });
});

// Hero
var swiper = new Swiper(".hero-slider", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
    },
  });
// About
var swiper = new Swiper(".about-slider", {
    slidesPerView: 1.5,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    breakpoints: {
        360: {
            slidesPerView: 1.3,
        },
        768: {
            slidesPerView: 1.3,
        },
        1024: {
            slidesPerView: 2.3,
        },
        1440: {
            slidesPerView: 2.3,
        },
        1920: {
            slidesPerView: 3.3,
        },
    },
});

// Venues & Spaces
var swiper = new Swiper(".venues-spaces-slider", {
    slidesPerView: 1,
    spaceBetween: 8,
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next.vs-arrw-nxt',
        prevEl: '.swiper-button-prev.vs-arrw-prv',
    },
    breakpoints: {
        640: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 2,
        },
        1280: {
            slidesPerView: 4,
        },
        1920: {
            slidesPerView: 6,
        },
    },
});

// Facilities
var swiper = new Swiper(".facilites_slider", {
    slidesPerView: 1.5,
    spaceBetween: 30,
    navigation: {
        nextEl: '.swiper-button-next.fac-nxt',
        prevEl: '.swiper-button-prev.fac-prv',
    },
    breakpoints: {
        360: {
            slidesPerView: 1.5,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 1.5,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 2.5,
        },
        1440: {
            slidesPerView: 2.5,
        },
        1920: {
            slidesPerView: 3.5,
        },
    },
});
